import {DatabaseViewType} from '@toolify/server/src/models/mongoose/DatabaseViewModel/enum/DatabaseViewType'

const TIME_AXIS_VIEW_TYPES: readonly DatabaseViewType[] = [
  DatabaseViewType.Timeline,
  DatabaseViewType.Gantt,
]

/**
 * Views that lay records out on a horizontal time axis. They share grouping, hidden-group and
 * show-all-groups behaviour, so a new axis view only has to be added here.
 */
export function isTimeAxisViewType(viewType: DatabaseViewType | null | undefined): boolean {
  return !!viewType && TIME_AXIS_VIEW_TYPES.includes(viewType)
}
